import { FC } from 'react';
import {
  HeroConversationMessage,
  ConversationMessageType,
} from '@vs-online-only-app/state';
import { Box, Stack, Chip, Typography } from '@mui/material';
import { Check, Send } from '@mui/icons-material';

type Props = {
  message: HeroConversationMessage;
};

const InviteToContactsMessage: FC<Props> = ({ message }) => {
  return (
    <>
      <Box minHeight={(theme) => theme.spacing(2)} />
      <Stack alignItems="center">
        <Chip
          label={
            <Stack
              alignItems="center"
              justifyContent="center"
              direction="row"
              gap={1}
            >
              {message.attributes.type ===
                ConversationMessageType.ContactsInvitationSent && <Send />}
              {message.attributes.type ===
                ConversationMessageType.ContactsInvitationAccepted && <Check />}
              <Typography variant="body2">
                Contacts invitation{' '}
                {message.attributes.type ===
                  ConversationMessageType.ContactsInvitationSent && 'sent'}
                {message.attributes.type ===
                  ConversationMessageType.ContactsInvitationAccepted &&
                  'accepted'}
                .
              </Typography>
            </Stack>
          }
        />
      </Stack>
      <Box minHeight={(theme) => theme.spacing(2)} />
    </>
  );
};

export default InviteToContactsMessage;
